<template>
  <div>
    <v-card elevation="0" class="pa-3">
      <v-card-text class="font-weight-bold text-h5">
        <v-row>
          <v-col cols="12" md="6">
            <div>
              Share Application Link
              <br />
              <div style="font-size: 0.9rem">
                Easily create a link for your application and send it to others.
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" style="text-align: right;">
            <v-btn right color="primary" large class="px-4" @click="createLink"
              ><v-icon>mdi-share</v-icon>
              View Link
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="modShare" width="500" persistent>
      <v-card :loading="loading">
        <v-card-title>New Application Link</v-card-title>
        <v-divider />
        <v-card-text class="my-6 font-weight-bold" style="font-size: 1.1rem">
          {{ appLink }}
          <v-btn icon><v-icon>mdi-content-copy</v-icon> </v-btn>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn class="px-5" color="primary" @click="closeShare"
            >Copy & Close</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    modShare: false,
    appData: {},
    vData: {},
    loading: false,
    appLink: "",
  }),

  methods: {
    createLink: async function () {
      this.modShare = true;
      this.loading = true;
      this.appData = {
        event_id: this.$store.state.eventInfo.EventId,
        venue_id: this.$store.state.eventInfo.VenueId,
        vendor_id: this.$store.state.eventInfo.VendorId,
      };
      await this.$axios
        .post("Vendor/vendorLink", this.appData)
        .then(async (res) => {
          if (res.data.status == "Success") {
            this.vData = res.data.result;
            this.appLink =
              "https://accred.dnanetworks.in/applink/" + res.data.result;

            await navigator.clipboard.writeText(this.appLink);
          } else {
            this.modShare = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeShare: async function () {
      await navigator.clipboard.writeText(this.appLink);
      this.modShare = false;
    },
  },
};
</script>

<style>
</style>